import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import shipOrderApi from '../apis/shipOrder.api'
import { PalletData } from '../apis/pallet.api'
import shipApi from '../apis/ship.api'
import palletService from '../services/pallet.service'
import confirmService from '../services/confirm.service'
import alertService from '../services/alert.service'
import downloadService from '../services/download.service'
import printService from '../services/print.service'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import { ActionName } from '../components/Actions'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import TableHorizontal, {
  TableHorizontalHeader
} from '../components/TableHorizontal'
import HeadingRow from '../components/HeadingRow'
import Button from '../components/Button'
import CardButton from '../components/CardButton'

interface ShipOrderRouteState {
  id: number
}

interface ShipOrderPalletsProps
  extends RouteComponentProps<any, any, ShipOrderRouteState> {}

interface ShipOrderPalletsState {
  pallets: PalletData[]
}

export default class ShipOrderPallets
  extends Component<ShipOrderPalletsProps, ShipOrderPalletsState> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Ship order"), path: 'ships.0.order.code' },
    { heading: i18n("Code"), path: 'code' },
    { heading: i18n("Pallet"), path: 'number' },
    { heading: i18n("Sales order"), path: 'ships.0.order.salesOrder' },
    { heading: i18n("Work order"), path: 'lastInternalTransfer.transferable.code' },
    { heading: i18n("Item"), path: 'item.code' },
    { heading: i18n("Description"), path: 'item.description' },
    { heading: i18n("Quantity"), path: 'ships.0.quantity' },
    { heading: i18n("Ship date"),
      path: 'ships.0.createdAt',
      date: true,
      tooltip: ['ships.0.createdUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: ShipOrderPalletsProps) {
    super(props)
    this.state = {
      pallets: []
    }
    this.handleExportClick = this.handleExportClick.bind(this)
    this.handlePrintClick = this.handlePrintClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get tableData () {
    const actions: ActionName[] = ['delete']
    return palletService.tableHorizontalData(this.state.pallets, actions)
  }

  listPallets () {
    shipOrderApi.listPallets(this.id, pallets => {
      if (!pallets) return
      this.setState({ pallets })
    })
  }

  handleExportClick () {
    shipOrderApi.exportPallets(this.id, pallets => {
      if (!pallets) {
        alertService.info('No results to export')
        return
      }
      downloadService.download(pallets, 'shipOrderPallets.csv')
    })
  }

  handlePrintClick () {
    shipOrderApi.printPallets(this.id, pallets => {
      if (!pallets) return
      printService.print(pallets)
    })
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to remove the pallet?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handleDeleteConfirm(id)
      }
      confirmService.push(confirm)
    }
  }

  handleDeleteConfirm (id: number) {
    const pallet = palletService.find(this.state.pallets, id)
    if (!pallet || !pallet.ships) return
    const ship = pallet.ships[0]
    shipApi.delete(ship.id, ship => {
      if (!ship) return
      const pallets = palletService.delete(this.state.pallets, pallet.id)
      this.setState({ pallets })
    })
  }

  componentDidMount () {
    this.listPallets()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Ship Order Pallets")}
              doc='ship-orders-view-ship-order-pallets'>
              <Button
                text={i18n("Export")}
                onClick={this.handleExportClick} />
              <Button
                text={i18n("Print")}
                onClick={this.handlePrintClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.headers}
              data={this.tableData}
              onActionClick={this.handleActionClick} />
            <CardButton cancelText={i18n("Back")} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}
